@if (init()) {
  <div class="section">
    <app-toolbar
      [user]="user()"
      [applicationName]="appConfig().applicationName"
    ></app-toolbar>

    <div class="content-area">
      <router-outlet></router-outlet>

      @if (loading()) {
        <div class="main-load main-load--content">
          <hard-loading></hard-loading>
        </div>
      }
    </div>
  </div>
}

@if (!init()) {
  <div class="main-load">
    <hard-loading></hard-loading>
  </div>
}

@if (openPopover()) {
  <div
    (click)="closePopover()"
    class="o_autocomplete-backdrop"
  ></div>
}
